module.exports = __webpack_public_path__ + "img/logo.2477e6a5.png";